/**
 * This file is the main entry point for the entire app.
 *
 * If the application is being bundled, this is where the bundling process
 * starts.  If the application is being loaded by an es6 module loader, this
 * is the entry point.
 *
 * Point Webpack or SystemJS to this file.
 *
 * This module imports all the different parts of the application:
 * - 3rd party Libraries and app core module
 * - Services
 * - Components
 * - Submodules
 * - Top-level states
 * - UI-Router Transition Hooks
 */

import { ControllerService } from '../common/base/controller.service';
// Import the core app module
import { app } from './core';

import './modules';

import { fetchConfig } from './config';
import { loadPlausible } from './loadAnalytics';
import { loadTheme, loadTranslations } from './loadCustoms';

// Base Controller Service
app.service('controllerService', ControllerService);

fetchConfig().then((resp) => {
  const config = resp.data;
  const theme = config.frontendConfiguration.customPath;

  //
  // CONFIG - Setup globally
  //
  app.config(
    (
      envServiceProvider,
      fdTranslateModalProvider,
      $translatePartialLoaderProvider,
    ) => {
      'ngInject';
      // Set the name of this project/service which is required for feature flags
      envServiceProvider.setProject('kwh');
      loadTranslations(theme, $translatePartialLoaderProvider);
      loadPlausible();
      // Set available customs to translate modal
      fdTranslateModalProvider.setCustoms(envServiceProvider.custom);
    },
  );

  //
  // RUN - Setup globally
  //
  app.run(
    (
      $log,
      envService,
      editableOptions,
      $rootScope,
      appConfig,
      trackingService,
      deviceDetector,
    ) => {
      ('ngInject');
      editableOptions.theme = 'bs3';
      $log.debug(angular.toJson(envService.getEnvironment(), true));

      // Make app configuration globally accessible to all scopes
      $rootScope.$config = appConfig;
      $rootScope.$browser = deviceDetector.browser;

      $log.info(`build ${envService.build} on ${envService.getStage()} stage`);

      // Enable tracing (for tracking)
      // $trace.enable(1);

      // Enable tracking (only for production!)
      if (envService.isProduction() && appConfig.app.tracking) {
        trackingService.activate(appConfig.app.tracking);
      }
    },
  );

  // Create application-wide configuration
  app.factory(
    'appConfig',
    ($http, featureFlagService, configFactory, envService) => {
      'ngInject';
      if (!config.frontendConfiguration) {
        featureFlagService.featureFlags = config;
        return configFactory.create(config).config;
      }
      featureFlagService.featureFlags = config.frontendFeatures;
      // ugly but tenant service does not expose backend features and we dont want duplicated features
      featureFlagService.featureFlags.autoApplyStandingOrders =
        config.frontendConfiguration.autoApplyStandingOrders;

      featureFlagService.featureFlags.getPersonendatenFromAtruvia =
        config.frontendConfiguration.getPersonendatenFromAtruvia;

      envService.tenantGroup = config.tenantGroup;
      envService.countryCode = config.countryCode;

      return configFactory.create(config.frontendConfiguration).config;
    },
  );

  // OK let's gooo
  loadTheme(theme, () => {
    angular.bootstrap(document, [app.name]);
  });
});
